export default function({language}) {

    var config = {
        label: language["comment-label"],
        placeholder: language["comment-placeholder"]
    };

    return {
        config: config,
        extendsType: "text-area"
    };

};
